module.exports = __webpack_public_path__ + "static/media/prasad-photography.b007f879.png";